import { CDN_URL } from '../../apis/constants';

export const getIconPath = (symbol: string): string => {
  if (symbol.toUpperCase() === 'PM')
    return `/coins/${symbol.toLowerCase()}.svg`;

  return `${CDN_URL}/coins/${symbol.toUpperCase()}.png`;
};
